export const LANGS = {
    JAPANESE: "ja",
    ENGLISH: "en"
}

export const SCREEN_INFO_TOP = {
    type: 'TOP'
};

export const PATH = {
    BASENAME: "/"
}

export const SEASON = {
    SPRING: {code:'spring'},
    SUMMER: {code:'summer'},
    AUTUMN: {code:'autumn'},
    WINTER: {code:'winter'},
    ALL: {code:'all'},
}

export const BARRIER_FREE = {
    ELEVATOR: {code:'elevator'},
    TOILET: {code:'toilet'},
    SLOPE: {code:'slope'},
    ALL: {code:'all'},
}

export const MAPS = {
    AUTO_POPUP_DISTANCE : 5 //5m以内
}

export const isRestaurant = (data) => {
    if(!data){
        return false;
    }
    return data.category === 'restaurant';
};
export const isToilet = (data) => {
    if(!data){
        return false;
    }
    return data.category === 'toilet';
};
export const isStation = (data) => {
    if(!data){
        return false;
    }
    return data.category === 'station';
};
export const isFacility = (data) => {
    if(!data){
        return false;
    }
    return data.category === 'restaurant' || data.category === 'toilet';
};

export const nl2br = (str) => {
    let ret = str;
    ret = str.replaceAll("¥/", "<br />");
    return ret.replaceAll("\n", "<br />");
};

//------ 360°画像 ------
export const getInsta360Url = (data) => { 
    let ret = null; 
    if(data && data.insta360){
        ret = data.insta360;
    }
    return ret;
}

//----- 画像パス ------
export const getImagePaths = (path) => {
    let ret = [];
    if(path === ''){
        ret.push('no-image@3x.png');
    }
    else if(Array.isArray(path)){
        ret = path;
    }
    else{
        ret.push(path);
    }
    return ret;
}

//--- 画像スライダー default slick options ---
export const slickSettingsCard = {
    arrows: true,
    infinite: false,
    centerMode: false,
    dots:false,
    // slidesToShow: 3,
    // slidesToScroll: 3,
    responsive: [{
        breakpoint: 1200,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
        },
        breakpoint: 1000,
              settings: {
                   slidesToShow: 3,
                   slidesToScroll: 1,
         }
    },{
         breakpoint: 500,
              settings: {
                   slidesToShow: 2,
                   slidesToScroll: 1,
              }
         }
    ],
    //beforeChange: (current, next) => setImageIndex(next)
}

//--- GPSモジュール useGeolocated default options ---
export const geoPositionOptions = {
    positionOptions: {
        enableHighAccuracy: true,  // 高精度GPSを使わない
        maximumAge: 10000,         // 10秒以内ならキャッシュを返す
        timeout: 20000,            // 最大待ち時間
    },
    userDecisionTimeout: 5000,
    watchPosition: true,
    //suppressLocationOnMount : false, //コンポーネントがマウントされた直後に自動で座標を取得して state を更新しないようにする,
    isStopAutoReview : true //Nola Customize GPSによる自動再描写停止
}
